import { ContentSelect } from './styles'
import { ContentTypographyNavigation } from '../styles'
import { animationVariants, scaleVariant } from 'src/theme/animations/swipeIn'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import React, { useEffect, useState } from 'react'
import { HeaderLabels } from 'src/constants'
import { useI18nInstance } from 'src/provider/LocaleProvider'

export function LanguageSelectComponent() {
    const { languageOptions } = HeaderLabels()
    const i18n = useI18nInstance()
    const [selectedValue, setSelectedValue] = useState(i18n.language)

    const changeLanguage = (event: SelectChangeEvent) => {
        const selectedLanguage = event.target.value
        i18n.changeLanguage(selectedLanguage).then()
        setSelectedValue(selectedLanguage)
    }
    useEffect(() => {
        setSelectedValue(i18n.language)
    }, [i18n.language])
    return (
        <ContentSelect
            marginLeft={['medium', 'xmedium', 0, 'titlle']}
            animate="animate"
            variants={[
                animationVariants,
                animationVariants,
                animationVariants,
                scaleVariant,
            ]}
        >
            <FormControl>
                <Select
                    value={selectedValue}
                    onChange={changeLanguage}
                    displayEmpty
                    name="link"
                    inputProps={{ 'aria-label': 'Select' }}
                >
                    {languageOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            <ContentTypographyNavigation
                                variant={'h2'}
                                fontSize={'xxsmall'}
                                fontWeight={500}
                            >
                                {option.label}
                            </ContentTypographyNavigation>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </ContentSelect>
    )
}
